import React, { useEffect, useState } from 'react';

import { PanelsEnum } from '@ariksa/inventory-core/api';
import { Box, useDisclosure } from '@chakra-ui/react';
import { isEmpty, map, orderBy, sum } from 'lodash';
import { useSelector } from 'react-redux';

import formatNumber, {
  formatNumberWithComma,
} from 'components/DataDisplay/Utils/formatNumber';
import { IconTypes } from 'components/Icons';
import { getIcon } from 'components/Icons/Components';
import { getIconColor } from 'components/Icons/Components/getIconColor';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { selectCloudPostureOverview } from 'containers/Dashboard/CloudPostureOverview/selectors';
import { AllEntitiesDrawer } from 'containers/Dashboard/Drawers/AllEntitiesDrawer';
import { AllEntitiesDetailsProps } from 'containers/Dashboard/types';
import { renderResourcesWithIconAndCount } from 'containers/Dashboard/utils/utils';

export const InsightsForCloudNetworking: React.FC = () => {
  const { insightsForCloudNetworking } = useSelector(
    selectCloudPostureOverview,
  );
  const allEntitiesDisclosure = useDisclosure();
  const [details, setDetails] = useState<AllEntitiesDetailsProps>(
    {} as AllEntitiesDetailsProps,
  );
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setTotal(sum(Object.values(insightsForCloudNetworking.data)));
  }, [insightsForCloudNetworking.data]);

  const getPanel = key => {
    switch (key) {
      case IconTypes.PublicIPs:
      case IconTypes.ExternallyAccessibleCompute:
        return PanelsEnum.ExternallyAccessiblePublicIps;
      case IconTypes.PublicSubnets:
        return PanelsEnum.ExternallyAccessiblePublicSubnets;
      case IconTypes.AnomalousTraffic:
        return PanelsEnum.AnomalousActivityMachines;
      case IconTypes.PublicVMsWithSSHOpen:
        return PanelsEnum.OpenSshPublicMachines;
      case IconTypes.VMsWithSSHOpen:
        return PanelsEnum.OpenSshMachines;
    }
  };

  return (
    <>
      <DashboardWidget
        isLoading={insightsForCloudNetworking.isLoading}
        label="Insights for Cloud Networking"
        noData={isEmpty(insightsForCloudNetworking.data)}
        noDataMessage="No insights available"
        styles={{ contentWrapper: { px: 0, pb: 0 } }}
        subHeader={
          formatNumberWithComma(total) + ' entit' + (total === 1 ? 'y' : 'ies')
        }
        content={
          <Box w="full" h="full" overflow="auto">
            {renderResourcesWithIconAndCount(
              orderBy(
                map(insightsForCloudNetworking.data, (count, key) => ({
                  label: key!,
                  icon: getIcon(key),
                  count: formatNumber(count),
                  value: count,
                  iconColor: getIconColor(IconTypes.Aws),
                  onClick: () => {
                    allEntitiesDisclosure.onOpen();
                    setDetails({
                      panel: getPanel(key)!,
                      iconType: key,
                      total: count,
                    });
                  },
                })),
                ['value'],
                ['desc'],
              ),
            )}
          </Box>
        }
      />
      <AllEntitiesDrawer
        isOpen={allEntitiesDisclosure.isOpen}
        onClose={allEntitiesDisclosure.onClose}
        {...details}
      />
    </>
  );
};
